import angular from 'angular';
import shared from 'modules/shared';

import message from './message';

import ExtractDomainFilter from './ExtractDomainFilter';
import MessageContentFilter from './MessageContentFilter';
import MessageMediaFilter from './MessageMediaFilter';

import { MessageService } from './MessageService';
import MessageParser from './MessageParser';

//
export default angular
    .module('message', [shared])
    .component('message', message)
    .filter('extractDomain', ExtractDomainFilter.factory)
    .filter('messageContent', MessageContentFilter.factory)
    .filter('messageMedia', MessageMediaFilter.factory)
    .service('MessageService', MessageService)
    .service('MessageParser', MessageParser).name;
